import Instance from "../../../../Axios";

// New Actions for the app

const GetValorOrcamentado =
  (parceirosId, dataInicio, dataFim) => async (dispatch) => {
    await Instance()
      .get(`/energias/dashboard/valorOrcamentado`, {
        params: { parceirosId, dataInicio, dataFim },
      })
      .then(({ data }) => {
        //   console.log(data);
        dispatch({
          type: "GET_VALOR_ORCAMENTADO",
          payload: data.yData[0].valorOrcamentado,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export default GetValorOrcamentado;
